// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#search-input:focus{border:none;box-shadow:none}#w-footer{margin-top:50px}#w-footer li{padding:15px 0}#w-footer li a{color:#787896 !important}", ""]);
// Exports
module.exports = exports;
